import { ca } from '@cian/analytics';

export function trackShowAwardsBlock(): void {
  ca('eventSite', {
    action: 'show_awards',
    category: 'Promo',
    name: 'oldevent',
    useLastProducts: true,
  });
}
